import React from "react";
import Page from "./Page";
import GrundzuegeDesStrafprozessrechts from "./grundzuege-des-strafprozessrechts-5.png";

export default class NewsPage extends React.Component {
  render() {
    return (
      <Page title="Aktuell" headerImage={GrundzuegeDesStrafprozessrechts}>
        <div role="article">
          <h3>Grundzüge des Strafprozessrechts: Neuerscheinung Oktober 2025</h3>
          <div>
            <h4>Verlagsankündigung</h4>
            <p>
              Die fünfte Auflage von Niklaus Oberholzers «Grundzüge des
              Strafprozessrechts» ist mehr als ein Update – sie ist ein
              Volltreffer für alle, die Strafverfahren verstehen, steuern oder
              verteidigen müssen. Anstatt Einzelartikel trocken zu kommentieren,
              vernetzt der Autor Ermittlungs-, Haupt- und Rechtsmittelverfahren
              zu einem dynamischen Gesamtbild und zeigt, wo formalisierte
              Abläufe an ihre rechtsstaatlichen Grenzen stossen. Seine
              einzigartige Vierfach-Perspektive als Untersuchungsrichter,
              Strafverteidiger, Präsident einer Beschwerdeinstanz und
              Bundesrichter garantiert Praxisnähe und kritische Distanz
              zugleich. Aktuelle Gesetzgebung und Bundesgerichtspraxis werden
              prägnant eingeordnet, Divergenzen offengelegt und Trends bewertet.
              Ob Kanzlei, Staatsanwaltschaft, Gericht oder Hörsaal – dieses Buch
              liefert verlässliche Orientierung, schärft den Blick für
              Grundprinzipien und macht deutlich, woran sich eine moderne
              Strafrechtspflege messen lassen muss.
            </p>
            <p>
              Erhältlich beim{" "}
              <a
                href="https://staempflirecht.ch/grundzuege-des-strafprozessrechts/ean-9783727243301"
                target="_blank"
                rel="noopener noreferrer"
              >
                Stämpfli Verlag
              </a>
              .
            </p>
            <img
              src={GrundzuegeDesStrafprozessrechts}
              className="page__article__image"
              alt="Grundzüge des Strafprozessrechts von Niklaus Oberholzer"
            />
          </div>
        </div>
      </Page>
    );
  }
}
